import { defineComponent as _defineComponent } from 'vue'
import { inject, computed } from 'vue'
import { GeoImagesViewModelKey } from '../keys/GeoImagesViewModel.key'
import InputText from '../../../../components/InputText/InputText.vue'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk.vue'
import DatePicker from '../../../../components/DatePicker/DatePicker.vue'
import RadioButtons from '../../../../components/RadioButtons/RadioButtons.vue'
import NewFileUpload from '../../../../components/NewFileUpload/NewFileUpload.vue'
import Button from '../../../../components/Button/Button.vue'
import HelpTooltip from '../../../ui/components/HelpTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoImageForm',
  setup(__props) {

const vm = inject(GeoImagesViewModelKey)!

const farmDropdownOptions = computed(() => {
	return vm.farmOptions.value.map((farm) => ({
		id: farm.id,
		Código: farm.code,
		Nome: farm.name,
	}))
})

const selectedFarmId = computed({
	get: () => vm.model.value.farm.id,
	set: (id: string) => {
		const farm = vm.farmOptions.value.find((f) => f.id === id)
		if (farm) {
			vm.model.value.farm = { name: farm.name, id: farm.id! }
		} else {
			vm.model.value.farm = { name: '', id: '' }
		}
	},
})

const acquisitionDateIso = computed({
	get: () => vm.model.value.acquisitionDate?.toISOString() ?? '',
	set: (isoString: string) => {
		vm.model.value.acquisitionDate = isoString ? new Date(isoString) : null
	},
})

const maxAcquisitionDateIso = new Date().toISOString()

const formTitle = computed(() =>
	vm.model.value.id ? 'Editar Cadastro de Imagem' : 'Cadastrar Imagem',
)

const uploadedFiles = computed(() => (vm.model.value.image ? [vm.model.value.image] : []))

vm.fetchFarms()

return { __sfc: true,vm, farmDropdownOptions, selectedFarmId, acquisitionDateIso, maxAcquisitionDateIso, formTitle, uploadedFiles, InputText, DropdownFk, DatePicker, RadioButtons, NewFileUpload, Button, HelpTooltip }
}

})